import chroma from "chroma-js";
import map from "lodash/map";
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import ColorToggler from "./colorToggler";
import Styled from "./colorWidget.styled";
const position = {
    my: "left bottom",
    at: "left top",
    offset: {
        x: 0,
        y: 0
    }
};
function ColorWidget({ className, value, onChange, hasClearBtn, placeholder, readOnly, disabled, zIndex, presetColors, fieldName }) {
    const popoverRef = useRef(null);
    const [draftColor, setDraftColor] = useState(value || "");
    const draftColorRef = useRef(value || "");
    const sketchPickerPresetColors = useMemo(() => map(presetColors, color => ({
        color,
        title: color
    })), [presetColors]);
    useEffect(() => {
        if (draftColorRef.current !== value) {
            draftColorRef.current = value || "";
            setDraftColor(value || "");
        }
    }, [value]);
    const handleValueChanged = useCallback((color) => {
        draftColorRef.current = color.hex;
        setDraftColor(color.hex);
    }, [onChange]);
    const handleValueChangedComplete = useCallback((color, evt) => {
        var _a;
        onChange && onChange(color.hex, fieldName);
        if (evt.type === "click") {
            (_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance.hide();
        }
    }, [onChange, fieldName]);
    const handleClear = useCallback((evt) => {
        var _a, _b;
        evt.stopPropagation();
        onChange && onChange("", fieldName);
        if ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) {
            (_b = popoverRef.current) === null || _b === void 0 ? void 0 : _b.instance.hide();
        }
    }, [onChange, fieldName]);
    const valid = !value || chroma.valid(draftColor);
    const resultColor = valid ? value || "" : "";
    return (React.createElement(ColorToggler, { className: className, placeholder: placeholder, disabled: disabled || readOnly, zIndex: zIndex, popoverRef: popoverRef, popoverClassName: "no-popover-arrow unselectable", ignoreHidingWhenChanged: true, color: resultColor, position: position, onClear: handleClear, hasClearBtn: hasClearBtn, popoverContent: React.createElement(Styled.SketchPicker, { disableAlpha: true, onChange: handleValueChanged, onChangeComplete: handleValueChangedComplete, color: draftColor, presetColors: sketchPickerPresetColors }) }));
}
export default memo(ColorWidget);
ColorWidget.defaultProps = {
    presetColors: [
        "#b80000",
        "#f44336",
        "#e91e63",
        "#9c27b0",
        "#673ab7",
        "#3f51b5",
        "#2196f3",
        "#00bcd4",
        "#009688",
        "#4caf50",
        "#8bc34a",
        "#cddc39",
        "#ffeb3b",
        "#ffc107",
        "#ff9800",
        "#ff5722"
    ]
};
